import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

let cache = null;

/** Global on/off switches set by the super-admin (all off by default). */
export function usePublicFeatures() {
  const [f, setF] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    axios.get(`${API}/public/features`).then(({ data }) => { cache = data; setF(data); }).catch(() => {});
  }, []);
  return f;
}
